export const devices = Object.freeze({
  DESKTOP_BIG: Symbol('DesktopBig'),
  DESKTOP: Symbol('Desktop'),
  DESKTOP_SMALL: Symbol('DesktopSmall'),
  TABLET: Symbol('Tablet'),
  MOBILE: Symbol('Mobile'),
})
